import { Button } from 'antd';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { issuesActions } from '@sonar-software/sonar-issues';
import { RestoreIcon } from '@ui/icons';
import { useAction } from '@hooks';
import React, { useCallback } from 'react';
export const RestoreIssueButton = ({ sonarObjectId }) => {
    const restoreIssueVisility = useAction(issuesActions.requestDeleteIssuesByIdVisibility);
    const handleRestoreClick = useCallback((e) => {
        e.stopPropagation();
        restoreIssueVisility({ sonarObjectId });
    }, [restoreIssueVisility, sonarObjectId]);
    return (React.createElement(Button, { icon: React.createElement(RestoreIcon, null), id: `restore-issue-${sonarObjectId}`, onClick: handleRestoreClick, type: 'default' }, COPY_SPECIFIC.RESTORE));
};
